module.exports = __webpack_public_path__ + "assets/HomeMarker-a026f3.svg";